const digest = '585f1359c54c385a2cb9081d1bf650afecb7f3af6d92aebd82001123d8e816fb';
const css = `._loaderContainer_1e7gs_1{height:42.1875rem}@media (1024px <= width){._loaderContainer_1e7gs_1{height:38.1875rem}}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'loaderContainer': '_loaderContainer_1e7gs_1' };
export const loaderContainer = '_loaderContainer_1e7gs_1';
export { css, digest };